import { message } from 'antd'

export const handler = (err) => {
  if (!err.name) return
  message.error(err.message)
}
